import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class IpoCancelUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.getIpoCancel(req);
    }
}
export default IpoCancelUseCase;
